module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.titre) ? _c('book-drawer', {
    attrs: {
      "id": _vm.titre.livres && _vm.titre.livres[0].id
    },
    scopedSlots: _vm._u([
      ["default", function(ref) {
        var livre = ref.livre;

        return [_vm._t("default", null, {
          titre: _vm.titre,
          livre: livre
        })]
      }]
    ])
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d33b6a7c"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/presentation/titre-drawer.vue
// module id = 1365
// module chunks = 1